import nengi from 'nengi'
import { uuid } from '../../utils/primitive-types'

class IdentifyItemCommand {
	static protocol = {
		itemId: nengi.String,
	}
	itemId: uuid
	/**
	 * Creates an instance of IdentifyItemCommand. This will attempt to mark an item as identified.
	 * @param {uuid} itemId Item ID
	 * @memberof IdentifyItemCommand
	 */
	constructor(itemId: uuid) {
		this.itemId = itemId
	}
}

export default IdentifyItemCommand
